import { FC, memo } from 'react';

type PropsT = {
  fill?: string;
};

const LikeSolidIcon: FC<PropsT> = ({ fill = 'none' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.56927 3.90434L7.99992 4.63457L8.43062 3.90437C9.10886 2.75447 10.313 1.99902 11.6792 1.99902C13.7701 1.99902
         15.5 3.7715 15.5 6.00195C15.5 7.20668 14.9905 8.28051 14.1911 9.01255L8.0804 13.9396L8.05555 13.9596L8.03346
         13.9827C8.02093 13.9957 8.00845 13.999 7.99995 13.999C7.99146 13.999 7.97897 13.9957 7.96644 13.9827L7.94435
         13.9596L7.91951 13.9396L1.80879 9.01255C1.00949 8.28053 0.5 7.20669 0.5 6.00195C0.5 3.77142 2.22943 1.99902
         4.32026 1.99902C5.68647 1.99902 6.89117 2.75454 7.56927 3.90434Z"
    />
  </svg>
);

export default memo(LikeSolidIcon);
import { FC, memo } from 'react';

type PropsT = {
  fill?: string;
};

const LikeSolidIcon: FC<PropsT> = ({ fill = 'none' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.56927 3.90434L7.99992 4.63457L8.43062 3.90437C9.10886 2.75447 10.313 1.99902 11.6792 1.99902C13.7701 1.99902
         15.5 3.7715 15.5 6.00195C15.5 7.20668 14.9905 8.28051 14.1911 9.01255L8.0804 13.9396L8.05555 13.9596L8.03346
         13.9827C8.02093 13.9957 8.00845 13.999 7.99995 13.999C7.99146 13.999 7.97897 13.9957 7.96644 13.9827L7.94435
         13.9596L7.91951 13.9396L1.80879 9.01255C1.00949 8.28053 0.5 7.20669 0.5 6.00195C0.5 3.77142 2.22943 1.99902
         4.32026 1.99902C5.68647 1.99902 6.89117 2.75454 7.56927 3.90434Z"
    />
  </svg>
);

export default memo(LikeSolidIcon);
